import styles from '../styles/PCButton.module.scss';

interface ButtonSmallerProps {
    label: string;
    color: string;
    onClick: () => void;
}

const PCButtonSmaller: React.FC<ButtonSmallerProps> = ({ label,color, onClick }) =>  {


    return (
        <div className={styles.ButtonSmaller} onClick={onClick} style={{backgroundColor: color}}>
            {label}
        </div>
    );
}

export default PCButtonSmaller;
